import { convertStringArray, ParseQsValue } from 'modules/utils/queryString';
import { StoreType } from 'types/common';
import { STORE_DETAIL_URLS } from 'constants/marketplace/revenue';
import { GameType } from 'types/marketplace/index';
import { Nullable } from 'types/common';


export const ItemDetailUrl = ({ 
  itemId, 
  store, 
  gameType 
}: { 
  itemId: string; 
  store: StoreType; 
  gameType?: Nullable<GameType>;
}): string => {
  if (store === StoreType.GAMEWEAR && gameType) {
    return `${STORE_DETAIL_URLS[store]}/${gameType}/detail/${itemId}`;
  }
  return `${STORE_DETAIL_URLS[store]}/${itemId}`;
};

export const parseStoreQueryString = (
  store: ParseQsValue,
  initialStore: StoreType[],
): StoreType[] => {
  return convertStringArray(store)?.map(store => Number(store)) ?? initialStore;
};
